import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import type { ActivatedRouteSnapshot } from '@angular/router';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { LoaderService } from '@studiobuki/web-core/lib/loader';
import { combineLatest, filter, map } from 'rxjs';
import { HeaderService } from '@studiobuki/web-core/lib/header';
import { UserService } from '@studiobuki/web-core/lib/user';
import { Logger } from '@shared/common/logger';
import { ELayoutFooter, ELayoutHeader } from '@studiobuki/web-core/lib/routing';
import { GATrack } from 'src/analytics';
import { updateMetaFroebelkan } from '@shared/jp/meta';
import type { TBookData } from '@shared/jp/models';
import type { TProductAlias } from '@shared/jp/product';
import { footerMainMenu, footerSideMenu } from './data/footer/data';

const log = new Logger('AppComponent');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private readonly marginTop$ = this.headerService.topbarHeight$.pipe(
    map((val) => `${val}px`),
  );

  private readonly overflow$ = this._loaderService.shown$.pipe(
    map((shown) => (shown ? 'hidden' : null)),
  );

  public readonly style$ = combineLatest([
    this.marginTop$,
    this.overflow$,
  ]).pipe(
    map(([marginTop, overflow]) => ({
      marginTop,
      overflow,
    })),
  );

  public LayoutHeader?: ELayoutHeader;

  public LayoutFooter?: ELayoutFooter;

  public readonly LAYOUT_HEADER = ELayoutHeader;

  public readonly LAYOUT_FOOTER = ELayoutFooter;

  public readonly footerMainMenu = footerMainMenu;

  public readonly footerSideMenu = footerSideMenu;

  constructor(
    public router: Router,
    public headerService: HeaderService,
    private _route: ActivatedRoute,
    private _loaderService: LoaderService,
    private _user: UserService<TProductAlias, TBookData>,
  ) {
    if (this.router.navigated) {
      this._setRouteData(this._getLastRouteState(this._route.snapshot));
    }

    this.router.events
      .pipe(
        filter(
          (event): event is ActivationEnd => event instanceof ActivationEnd,
        ),
      )
      .subscribe((event) => {
        this._setRouteData(this._getLastRouteState(event.snapshot));
        GATrack('page_view');
      });

    this._user.init().catch((err) => log.error(err));
  }

  ngOnInit() {
    // this.translateService.use(environment.defaultLocale);
  }

  private _setRouteData(snapshot: ActivatedRouteSnapshot) {
    const url = window.location.pathname.slice(1);

    updateMetaFroebelkan(url, window.document);

    const { LayoutHeader, LayoutFooter } = snapshot.data;

    this.LayoutHeader =
      LayoutHeader !== undefined ? LayoutHeader : ELayoutHeader.shown;
    this.LayoutFooter =
      LayoutFooter !== undefined ? LayoutFooter : ELayoutFooter.shown;
  }

  private _getLastRouteState(
    snap: ActivatedRouteSnapshot,
  ): ActivatedRouteSnapshot {
    const firstChild = snap.children[0];

    if (firstChild) {
      return this._getLastRouteState(firstChild);
    }

    return snap;
  }
}
